import { clsx } from 'clsx'

interface BadgeProps {
  type: 'positive' | 'negative'
}

export default function Badge({ type }: BadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
        type === 'positive' && 'bg-green-100 text-green-700',
        type === 'negative' && 'bg-red-100 text-red-700',
      )}
    >
      {type === 'positive' ? 'Positive' : 'Negative'}
    </span>
  )
}
